import { useEffect, useMemo, useState } from 'react';
import { useI18n } from '../i18n';
import { countries, type Country } from '../lib/countries';
import { getCountryPath } from '../lib/outline';
import DistanceGame from './DistanceGame';

function OutlineSvg({ answer }: { answer: Country }) {
  const [d, setD] = useState('');
  useEffect(() => {
    let on = true;
    setD('');
    getCountryPath(answer.ccn3, 300, 200).then((p) => {
      if (on && p) setD(p);
    });
    return () => {
      on = false;
    };
  }, [answer.ccn3]);

  return (
    <svg className="outline-svg" viewBox="0 0 300 200" role="img" aria-label="Country shape">
      {d && <path d={d} />}
    </svg>
  );
}

export default function OutlineMode({ endless = false }: { endless?: boolean }) {
  const { t } = useI18n();
  // 只从有轮廓几何的国家出题,避免谜面空白
  const pool = useMemo(() => countries.filter((c) => c.hasOutline), []);
  return (
    <DistanceGame
      mode="outline"
      prompt={t.puzzle.outline}
      pool={pool}
      endless={endless}
      renderPuzzle={(a: Country) => <OutlineSvg answer={a} />}
    />
  );
}
